<template>
  <el-dialog
    append-to-body
    width="700px"
    title="账号信息"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
  >
    <div style="margin-bottom: 15px">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="showAddAccount"
        >创建账号</el-button
      >
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="name" label="名称" width="180"></el-table-column>
      <el-table-column
        prop="account"
        label="账号"
        width="180"
      ></el-table-column>
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="handleEditPassword(row)"
            >修改密码</el-button
          >
          <el-button
            type="text"
            size="mini"
            class="delBtn"
            @click="handleDelete(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-button @click="toggle(false)">关闭</el-button>
    </template>

    <!-- 创建账号弹窗 -->
    <el-dialog
      append-to-body
      width="500px"
      title="创建账号"
      :visible.sync="addAccountVisible"
      :before-close="resetAddAccount"
      :close-on-click-modal="false"
    >
      <el-form
        ref="addAccountForm"
        label-width="100px"
        label-position="right"
        :model="addAccountFormData"
        :rules="addAccountFormRules"
      >
        <el-form-item prop="name" label="代理人员">
          <el-input
            placeholder="请输入代理人员姓名"
            v-model="addAccountFormData.name"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="account" label="联系电话">
          <el-input
            placeholder="请输入联系电话"
            v-model="addAccountFormData.account"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="password" label="登录密码">
          <el-input
            placeholder="请输入登录密码"
            v-model="addAccountFormData.password"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item prop="area" label="代理区域">
          <el-cascader
            disabled
            v-model="addAccountFormData.area"
            :options="areaOptions"
            :props="{ expandTrigger: 'hover' }"
            placeholder="请选择代理区域"
            clearable
          ></el-cascader>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <el-row type="flex" justify="end">
          <el-button @click="resetAddAccount">取消</el-button>
          <el-button
            type="primary"
            :loading="addAccountLoading"
            :disabled="addAccountLoading"
            @click="confirmAddAccount"
            >确定</el-button
          >
        </el-row>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  name: "AccountDialog",
  data() {
    return {
      visible: false,
      agentId: null,
      agentName: "",
      tableData: [],
      areaOptions: [],
      // 创建账号弹窗相关
      addAccountVisible: false,
      addAccountLoading: false,
      addAccountFormData: {
        name: "",
        account: "",
        password: "",
        area: [],
      },
      addAccountFormRules: {
        name: [
          { required: true, message: "请输入代理人员姓名", trigger: "blur" },
        ],
        account: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            pattern: /^.{6,}$/,
            message: "密码长度不能少于6位",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getArea();
  },
  methods: {
    getArea() {
      this.$http.get("/common/district/all", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.areaOptions = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toggle(show, row) {
      this.visible = show;
      if (show && row) {
        this.agentId = row.id;
        this.agentName = row.name;
        this.addAccountFormData.area = [row.province, row.city, row.area];
        this.getAccountList();
      }
      if (!show) {
        this.reset();
      }
    },
    reset() {
      this.agentId = null;
      this.agentName = "";
      this.tableData = [];
      this.visible = false;
    },
    getAccountList() {
      this.$http
        .get("/admin/companyAgent/accounts", {
          params: { id: this.agentId },
        })
        .then((res) => {
          if (res.code === 1) {
            this.tableData = res.data.list || [];
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    showAddAccount() {
      this.addAccountVisible = true;
    },
    resetAddAccount() {
      if (this.$refs.addAccountForm) {
        this.$refs.addAccountForm.resetFields();
      }
      this.addAccountFormData.name = "";
      this.addAccountFormData.account = "";
      this.addAccountVisible = false;
    },
    confirmAddAccount() {
      this.$refs.addAccountForm.validate((valid) => {
        if (valid) {
          this.addAccountLoading = true;
          const params = {
            ...this.addAccountFormData,
            agent_id: this.agentId,
            // province: this.addAccountFormData.area[0],
            // city: this.addAccountFormData.area[1],
            // area: this.addAccountFormData.area[2],
          };
          this.$http
            .post("/admin/companyAgent/addAccount", params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("创建成功！");
                this.addAccountVisible = false;
                this.resetAddAccount();
                this.getAccountList();
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.addAccountLoading = false;
            });
        }
      });
    },
    handleEditPassword(row) {
      this.$prompt("请输入新密码", "修改密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{6,}$/,
        inputErrorMessage: "密码长度不能少于6位",
      })
        .then(({ value }) => {
          this.$http
            .post("/admin/companyAgent/changePwd", {
              id: row.id,
              password: value,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("密码修改成功！");
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    handleDelete(row) {
      this.$confirm("确认删除该账号？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/admin/companyAgent/deleteAccount", {
              id: row.id,
              agent_id: row.agent_id,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("删除成功！");
                this.getAccountList();
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.delBtn {
  color: #f56c6c;
}
</style>